import { memo, useEffect, useState } from "react"
import ProductList from "@/components/product/list"
import ProductService from "@/services/product"
import ProductTagService from "@/services/product_tag"
import ProductCategoryService from "@/services/product_category"
import { Box, Button, Spacer, Stack, Text } from "@chakra-ui/react"
import HomeBanner from "./HomeBanner";
import { Tabs } from "@chakra-ui/react"
import { LuCheck, LuFolder, LuSquareCheck, LuUser } from "react-icons/lu"
import Videos from "./blocks/videos"
import _ from "lodash"
import Block from "./Block"
import { useStore } from "contexts/store"





const Home = () => {
    const { store } = useStore()
    const [blocks, setBlocks] = useState(store.home_page.blocks)
    useEffect(() => {
        if (window != window.top)
            setBlocks(store.home_page.blocks);
    }, [store])


    // const tags = [{ name: "Tất cả", id: "all" }, { name: "Phổ biến", id: "phổ biến" }]
    return (
        <div>

            <Stack>
             
                {blocks.map(x => <Block data={x}></Block>)}

            </Stack>

        </div>
    )
}





export default memo(Home)